const selectors = {
  data: (state) => state.createEvent.data,
  submitEventCreationStatus: (state) =>
    state.createEvent.submitEventCreationStatus,
  editEventStatus: (state) => state.createEvent.editEventStatus,
};

export { selectors };
